import { createSelector } from 'reselect'

export const selectCateringStores = createSelector(
  [state => state.cateringStores.cateringSchedule],
  cateringSchedule => cateringSchedule,
)
